var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect',{attrs:{"options":_vm.statusList,"multiple":true,"label":"name","track-by":"name","placeholder":"Type to search for pay status","open-direction":"bottom","searchable":true},on:{"input":_vm.updateValue},model:{value:(_vm.selectedStatus),callback:function ($$v) {_vm.selectedStatus=$$v},expression:"selectedStatus"}})
}
var staticRenderFns = []

export { render, staticRenderFns }